import React from 'react'
import TabsFlightHotal from '../components/TabsFlightHotal'
import HeaderBottom from "../assets/header-bottom-shap.png"
import Stops from '../components/Stops'
import Airlines from '../components/Airlines'
import FlightTimes from '../components/FlightTimes'
import Duration from '../components/Duration'
import FlightList from '../components/FlightList'
import { useTranslation } from 'react-i18next'

const Flights = () => {
  const { t } = useTranslation();
  return (
     <main className="main position-relative">
        <div className="bottom-main-shap position-absolute top-0">
            <img src={HeaderBottom} alt="" />
        </div>
        <TabsFlightHotal />
        
        <div className="trip-main-sec position-relative z-1 mb-md-5 mb-4 mt-md-5 mt-4">
            <div className="btn-filter-box d-lg-none ">
                <button className="btn btn-menu border-0" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasExampleFilterHotal" aria-controls="offcanvasExample">
                    {t("filterTitle")}
                    <i className="fas fa-bars"></i>
                </button>
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-lg-4 col-md-12  mb-lg-0 mb-4">
                         <div className="offcanvas offcanvas-start filter-box-sec" tabIndex="-1" id="offcanvasExampleFilterHotal" aria-labelledby="offcanvasExampleLabel">
                            <div className="trip-left-sec mb-md-0 mb-4"> 
                                <button type="button" className="btn-close d-lg-none d-block" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                                <div className="heading"> 
                                    <h4>{t("filterResults")} <span>{t("showing")}</span></h4>
                                </div>
                                <Stops />
                                <Airlines />
                                <FlightTimes />
                                <Duration />
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-8 col-md-12">
                        <div className="trip-right-sec">
                            <FlightList />
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </main>
  )
}

export default Flights